<template>
  <RevInfoBlock
    :cta="i18n(translations.cta)"
    :icon="IconInfo"
    :title="i18n(translations.title)"
    variant="info"
    @click="handleClick"
  >
    <p>{{ i18n(translations.subtitle) }}</p>
  </RevInfoBlock>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconInfo } from '@ds/icons/IconInfo'

import translations from './BmProInfoBlock.translations'

const props = defineProps<{
  utmSource: string
  zone: string
  name: string
}>()

const i18n = useI18n()
const { trackClick } = useTracking()
const { market } = useMarketplace()

const UTM_MEDIUM = 'website'
const UTM_CAMPAIGN = `LIF_B2B_ALL_${market.countryCode}_INAP_BM4BConvergenceRedirection`
const UTM_CONTENT = 'dashboard'

const proUrl = `https://pro${market.domain}/?utm_source=${props.utmSource}&utm_medium=${UTM_MEDIUM}&utm_campaign=${UTM_CAMPAIGN}&utm_content=${UTM_CONTENT}`

function handleClick() {
  trackClick({ zone: props.zone, name: props.name })
  window.open(proUrl, '_blank', 'noopener,noreferrer')
}
</script>
